module.exports = __webpack_public_path__ + "static/img/image028.e78b9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image028.png
// module id = UgR4
// module chunks = 1